import { Search } from '@carbon/icons-react';
import * as React from 'react';
import { MosaicKey } from 'react-mosaic-component/lib/types';
import { Input } from 'vet-bones/design-system/components';

import { MosaicViewManager } from 'src/components/mosaic/MosaicViewManager';
import {
  MosaicCollapseOptionsById,
  MosaicCollapsedById,
} from 'src/components/mosaic/types';
import {
  SidebarSection,
  SidebarSectionType,
} from 'src/components/sidebarSection/SidebarSection';
import {
  MosaicSplitOptions,
  NestedMosaicParentInitial,
} from 'src/constants/mosaic';
import { TEST_IDS } from 'src/constants/testIds';

import styles from 'src/components/sidebar/sidebar.module.scss';

export type SidebarProps<T extends MosaicKey> = {
  filter: string;
  collapseOptions: MosaicCollapseOptionsById<T>;
  initialValue: NestedMosaicParentInitial<T>;
  splitOptions: MosaicSplitOptions;
  onFilter: (filter: string) => void;
  onToggleCollapsed?: (collapsed: MosaicCollapsedById<T>) => void;
  sections: SidebarSectionType[];
};

export const Sidebar: React.VFC<SidebarProps<any>> = <T extends MosaicKey>({
  filter,
  collapseOptions,
  initialValue,
  splitOptions,
  onFilter,
  onToggleCollapsed,
  sections,
}: SidebarProps<T>) => (
  <div className={styles.sidebar}>
    <div className={styles.sidebarHeader}>
      <Input
        clearTestId={TEST_IDS.projectSidebar.filterClearButton}
        icon={Search}
        id="sidebar-search"
        label=""
        onChange={(evt) => onFilter(evt.target.value)}
        onClear={() => onFilter('')}
        placeholder="Search"
        size="md"
        testId={TEST_IDS.projectSidebar.filterInput}
        value={filter}
      />
    </div>
    <MosaicViewManager
      collapseOptions={collapseOptions}
      containerClassName={styles.sidebarSections}
      direction="column"
      initialValue={initialValue}
      onToggleCollapsed={onToggleCollapsed}
      splitOptions={splitOptions}
    >
      {sections.map((section) => (
        <SidebarSection
          key={section.id}
          filter={filter}
          id={section.id}
          section={section}
        />
      ))}
    </MosaicViewManager>
  </div>
);
